module.exports = __webpack_public_path__ + "36b99fba97a9398bde77414790224d3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-yarimasita.png
// module id = 2028
// module chunks = 4